export default "__VITE_ASSET__Cs_sn3yq__"